export const CONSONANT_VOWEL_PAIRS_JJ = [

    // ㅉ
  {
        id: 1,
        korean: "짜",
        english: "jja",

    },
    {
        id: 2,
        korean: "쩨",
        english: "jje",

    },
    {
        id: 3,
        korean: "찌",
        english: "jji",

    },
    {
        id: 4,
        korean: "쪼",
        english: "jjo",

    },
    {
        id: 5,
        korean: "쯔",
        english: "jjeu",

    },
    {
        id: 6,
        korean: "쩌",
        english: "jjeo",

    },
    {
        id: 7,
        korean: "쨔",
        english: "jjya",

    },
    {
        id: 8,
        korean: "째",
        english: "jjae",

    },
    {
        id: 9,
        korean: "쪠",
        english: "jjye",

    },
    {
        id: 10,
        korean: "쬬",
        english: "jjyo",

    },
    {
        id: 11,
        korean: "쪄",
        english: "jjyeo",

    },
    {
        id: 12,
        korean: "쮸",
        english: "jjyu",

        

    },

    {
        id: 13,
        korean: "짠",
        english: "jjan",

        

    },
    {
        id: 14,
        korean: "짴",
        english: "jjak",

        

    },
    {
        id: 15,
        korean: "찜",
        english: "jjim",
        

    },
    {
        id: 16,
        korean: "짯",
        english: "jjat",
        

    },
    {
        id: 17,
        korean: "짷",
        english: "jjah",
        

    },
    {
        id: 18,
        korean: "쩝",
        english: "jjeob",
        

    },
          {
        id: 19,
        korean: "쯜",
        english: "jjeul",
        

    },
    {
        id: 20,
        korean: "짵",
        english: "jjat",
        

    },
    {
        id: 21,
        korean: "짺",
        english: "jjaekk",
        

    },
    {
        id: 22,
        korean: "짼",
        english: "jjaen",
        

    },
    {
        id: 23,
        korean: "쯰",
        english: "jjui",
        

    },
    {
        id: 24,
        korean: "꿔",
        english: "jjwo",
        

    },

    {
        id: 25,
        korean: "쨪",
        english: "jjyat",
        

    },
    {
        id: 26,
        korean: "짵",
        english: "jjat",
        

    },
    {
        id: 27,
        korean: "짯",
        english: "jjat",
        
    },
    {
        id: 28,
        korean: "짤",
        english: "jjal",
        
    }
    
];

